import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Performance › Visitor Tracking (leaf).
export const visitorTracking: ContentPage = {
  slug: "sales-performance/visitor-tracking",
  template: "hrmsFeature",
  seo: {
    title: "Website Visitor Tracking - Identify & Convert Visitors | GetBiz CRM",
    description: "Turn website traffic into pipeline with GetBiz CRM visitor tracking. Identify visiting companies, see their interest, and reach out at the right time.",
    keywords: ["website visitor tracking", "visitor identification", "lead generation tracking", "crm visitor tracking"],
    ogImage: "/assets/data/seoimages/visitor-tracking.webp",
  },
  leaf: {
    hero: {
      caption: "Visitor Tracking",
      title: "Know Which Companies Visit Your Website",
      description: "Identify the companies browsing your site, see what they view, and turn anonymous traffic into warm, timely outreach.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Visitor Tracking",
      bullets: [
        { title: "Identify Companies", description: "See which companies visit, even anonymously." },
        { title: "Track Interest", description: "Know which pages and products they viewed." },
        { title: "Real-Time Alerts", description: "Get notified when a hot account is on your site." },
        { title: "Feed the Pipeline", description: "Turn visits into leads and timely follow-up." },
      ],
      image: "/assets/images/img/product/crm/visitor-tracking-lead-image.webp",
      imageAlt: "Visitor Tracking — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Performance",
      description: "Visitor Tracking connects to every other part of Sales Performance in GetBiz CRM.",
    },
    cards: [
      { title: "Forecasting", href: "/crm-software/sales-performance/forecasting/", description: "Build data-driven forecasts from your live pipeline, so leadership always has an accurate view of what will close.", image: "/assets/images/img/product/crm/forecasting.webp", imageAlt: "GetBiz CRM forecasting" },
      { title: "Multiple Currencies", href: "/crm-software/sales-performance/multiple-currencies/", description: "Quote, close and report across currencies with live exchange rates.", image: "/assets/images/img/product/crm/multiple-currencies.webp", imageAlt: "GetBiz CRM multiple currencies" },
      { title: "Analytics", href: "/crm-software/sales-performance/analytics/", description: "Dig into performance across reps, products and regions to understand the behaviors and deals that drive revenue.", image: "/assets/images/img/product/crm/analytics-sub.webp", imageAlt: "GetBiz CRM analytics" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Visitor Tracking in action.",
    relatedBlogs: "static",
    metaKey: "sales-performance-visitor-tracking",
  },
  sections: [],
};
